import * as React from "react";
import { SVGProps } from "react";
const SvgPause = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 24h-3c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h3c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1Zm10-1V9c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPause;
